import { memo } from "react";
import { WalkthroughHighlightStep } from "./walkthrough-highlight-step";
import { WalkthroughModalStep as WalkthroughModalStepComponent } from "./walkthrough-modal-step";
import { WalkthroughProgressBar } from "./walkthrough-progress-bar";
import {
  WalkthroughHighlightStep as HighlightStepType,
  WalkthroughModalStep as ModalStepType,
} from "./walkthrough-types";

export const WalkthroughOverlay = memo(function WalkthroughOverlay({
  step,
  stepIndex,
  totalSteps,
  totalSections,
  next,
  back,
  dismiss,
}: {
  step: ModalStepType | HighlightStepType;
  stepIndex: number;
  totalSteps: number;
  totalSections: number;
  next(): void;
  back(): void;
  dismiss(): void;
}) {
  const progressBar = step.section ? (
    <WalkthroughProgressBar
      dismiss={dismiss}
      section={step.section}
      totalSections={totalSections}
    />
  ) : null;

  if (step.type === "modal") {
    return (
      <>
        {progressBar}
        <WalkthroughModalStepComponent
          back={back}
          dismiss={dismiss}
          next={next}
          step={step}
          stepIndex={stepIndex}
          totalSteps={totalSteps}
        />
      </>
    );
  }

  return (
    <>
      {progressBar}
      <WalkthroughHighlightStep
        back={back}
        dismiss={dismiss}
        next={next}
        step={step}
        stepIndex={stepIndex}
        totalSteps={totalSteps}
      />
    </>
  );
});
